// Large-model Revit work has no overall frontend deadline. These limits only
// detect a stalled transport read or an operation Revit never accepts.
export const RevitProgressRequestTimeoutMs = 2 * 60_000;
export const RevitOperationAcceptanceTimeoutMs = 5 * 60_000;
export const RevitCatalogInspectionTimeoutMs = 5 * 60_000;

export interface RevitProgressRequestWorkload {
  familyCount?: number;
  parameterCount?: number;
}

const ProgressRequestWorkItemAllowanceMs = 500;
const MaximumAbortSignalTimeoutMs = 2_147_483_647;

const normalizeWorkItemCount = (value: number | undefined): number =>
  typeof value === 'number' && Number.isFinite(value) && value > 0 ? Math.floor(value) : 0;

export function getRevitProgressRequestTimeoutMs(
  workload: RevitProgressRequestWorkload = {}
): number {
  const familyCount = normalizeWorkItemCount(workload.familyCount);
  const parameterCount = normalizeWorkItemCount(workload.parameterCount);

  // The embedded connector can be unable to answer a progress read while the
  // Revit thread is opening families. Keep the transport read alive for the
  // amount of model work already reported instead of treating every model as
  // if it had the same two-minute ceiling.
  return Math.min(
    MaximumAbortSignalTimeoutMs,
    RevitProgressRequestTimeoutMs +
      (familyCount + parameterCount) * ProgressRequestWorkItemAllowanceMs
  );
}
